const permissions = {
  adminProduct: 'BP001',
  businessPartner: 'BP002',
  editBusinessPartner: 'BP003',
  publicReferencesMap: 'BP004',
  importPublicReferences: 'BP005',
  teamActions: 'BP006',
  editTeamActions: 'BP007',
  deleteTeamActions: 'BP008'
};

export default permissions;
